import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";
import { CLIENT_LOADED } from "../constants/actionTypes";
import * as agent from "../agent";
import { normalizeMoney } from "../utility";
import { MaterialTextField } from "./MaterialInput";
import PickRatesInput from "./PickRatesInput";
import SubmitButton from './SubmitButton';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

class loanSecurityCheck extends React.Component {
    state = {
        ptsChecked: false,
        holdChecked: false
    }
    togglePTS = () => {
        const { ptsChecked } = this.state;
        this.setState({ ptsChecked: !ptsChecked });
    }
    toggleHold = () => {
        const { holdChecked } = this.state;
        this.setState({ holdChecked: !holdChecked });
    }

    render() {
        const { handleSubmit, carId, holdDuration, ptsDuration, holdSum, ptsSum, onSecuritySubmit } = this.props;
        const { ptsChecked, holdChecked } = this.state;

        const prepareData = ({ ptsDuration, ptsRates, holdDuration, holdRates }) => {
            const { ptsSum, holdSum } = this.props;
            const { ptsChecked, holdChecked } = this.state;
            return Object.assign(
                {},
                ptsChecked ? { ptsSum, ptsDuration, ptsRates } : {},
                holdChecked ? { holdSum, holdDuration, holdRates } : {}
            );
        }

        return (
            <Paper className="common-paper">
                <Typography variant="h5" >Данные не используются</Typography>
                <Typography variant="h5" >Пересмотреть смысл форм?</Typography>
                <form onSubmit={ handleSubmit(data => onSecuritySubmit(carId, prepareData(data))) }>
                    <Grid container justify="center" spacing={16}>
                        <Grid item className="common-column common-form">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                      checked={ptsChecked}
                                      onChange={this.togglePTS} /> }
                                label="Предложение под ПТС" />
                            <Field component={MaterialTextField}
                                   name="ptsSum"
                                   disabled={!ptsChecked}
                                   normalize={normalizeMoney}
                                   endAdornment="₽"
                                   label="Сумма займа" />
                            <Field component={MaterialTextField}
                                   disabled={!ptsChecked}
                                   name="ptsDuration"
                                   select
                                   label="Срок займа" >
                                {Array(36).fill(0).map((_, i) => <MenuItem key={i} value={i+1}>{i+1} мес.</MenuItem>)}
                            </Field>
                            <Field component={PickRatesInput}
                                   name="ptsRates"
                                   duration={ptsDuration}
                                   sum={ptsSum} />
                        </Grid>
                        <Grid item className="common-column common-form">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                      checked={holdChecked}
                                      onChange={this.toggleHold} /> }
                                label="Предложение под стоянку" />
                            <Field component={MaterialTextField}
                                   name="holdSum"
                                   disabled={!holdChecked}
                                   normalize={normalizeMoney}
                                   endAdornment="₽"
                                   label="Сумма займа" />
                            <Field component={MaterialTextField}
                                   disabled={!holdChecked}
                                   name="holdDuration"
                                   select
                                   label="Срок займа" >
                                {Array(36).fill(0).map((_, i) => <MenuItem key={i} value={i+1}>{i+1} мес.</MenuItem>)}
                            </Field>
                            <Field component={PickRatesInput}
                                   name="holdRates"
                                   duration={holdDuration}
                                   sum={holdSum} />
                        </Grid>
                    </Grid>
                    <SubmitButton label="Одобрить" />
                </form>
            </Paper>
        );
    }
}


const LoanSecurityCheck = connect(
    state => {
        return {
            holdDuration: formValueSelector("loan-security-form")(state, "holdDuration"),
            ptsDuration: formValueSelector("loan-security-form")(state, "ptsDuration"),
            holdSum: Number(`${formValueSelector("loan-security-form")(state, "holdSum")}`.replace(/\s/g,``)),
            ptsSum: Number(`${formValueSelector("loan-security-form")(state, "ptsSum")}`.replace(/\s/g,``))
        };
    }
)(reduxForm({
    form: "loan-security-form",
})(loanSecurityCheck));

const mapDispatchToProps = (dispatch, {match}) => ({
    onSecuritySubmit: (id, details) =>
        agent.Clients.setSecurityDetails(id, details)
        .then(client => dispatch({type: CLIENT_LOADED, payload: client})),
});

export default connect(null, mapDispatchToProps)(LoanSecurityCheck);



// WEBPACK FOOTER //
// ./src/components/LoanSecurityCheck.js